import React from 'react';
import connectWithCore from 'framework/hocs/connectWithCore';
import {
  TextAreaField,
  Select,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {FemaGoTable} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import {getItemNameFromRef} from 'common/utils';
import {Segment, Header} from 'semantic-ui-react';
import _ from 'lodash';

export class TableDiscussion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scores: this.props.scores,
    };
  }

  componentDidMount() {
    const {scores} = this.props;
    const filteredScores = _.filter(scores, (score) => {
      return !_.isNaN(_.toNumber(score.part));
    });
    const filteredParts = _.uniq(
      _.map(filteredScores, (score) => {
        return score.part;
      })
    );
    REST.ref
      .getItemsByItemCodes(this.props.token, filteredParts)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          refItems: data,
        });
      })
      .catch((err) => {
        console.error('Error retrieving ItemCodes from Ref');
      });
  }

  handleChange = (name, value, modifiedScore) => {
    const {scores} = this.state;
    const {scoringOptions} = this.props;
    const scoresCopy = _.cloneDeep(scores);
    const modifiedScoreIndex = _.findIndex(scoresCopy, {
      part: modifiedScore.part,
      factor: modifiedScore.factor,
      userId: modifiedScore.userId,
    });
    _.set(scoresCopy, [modifiedScoreIndex, name], value);
    if (name === 'value') {
      const textValue = _.get(_.find(scoringOptions, {value: value}), 'text');
      _.set(scoresCopy, [modifiedScoreIndex, 'text'], textValue);
    }
    this.setState({
      scores: scoresCopy,
    });
  };

  saveScores = (modifiedScore, name) => {
    const {
      userId,
      saveEntityData,
      entityDataPath,
      entityType,
      validationId,
      userScores,
    } = this.props;
    const {scores} = this.state;
    const currentReviewerScores = _.filter(scores, {userId: userId});
    const modifiedScoreIndex = _.findIndex(userScores, {
      userId: modifiedScore.userId,
      part: modifiedScore.part,
      factor: modifiedScore.factor,
    });
    const validationPath = `${validationId}.0.scores.0.error[${modifiedScoreIndex}].${name}`;
    saveEntityData(entityDataPath, entityType, currentReviewerScores, validationPath);
  };

  isCurrentReviewer = (score) => {
    const {userId} = this.props;
    return _.get(score, 'userId') === userId;
  };

  getError = (modifiedScore, fieldName) => {
    const {validationDirtyMap, validationErrors} = this.props;
    const {userScores} = this.props;
    const scoresValidationPath = '0.scores.0.error';
    const modifiedScoreIndex = _.findIndex(userScores, {
      userId: modifiedScore.userId,
      part: modifiedScore.part,
      factor: modifiedScore.factor,
    });
    const fieldIsValid = _.get(
      validationErrors,
      `${scoresValidationPath}[${modifiedScoreIndex}].${fieldName}.0.isValid`
    );
    const fieldDisplayError =
      !fieldIsValid &&
      _.get(
        validationDirtyMap,
        `dirty.${scoresValidationPath}[${modifiedScoreIndex}].${fieldName}`
      );
    const fieldErrorMessage = _.get(
      validationErrors,
      `${scoresValidationPath}[${modifiedScoreIndex}].${fieldName}.0.message`,
      false
    );
    return {
      displayError: fieldDisplayError,
      errorMessages: fieldErrorMessage,
    };
  };

  renderEditableScores = (score) => {
    const {scoringOptions} = this.props;
    const {part, factor, justification, value} = score;
    return (
      <FemaGoTable.Row>
        <FemaGoTable.TextCell width={4}>You</FemaGoTable.TextCell>
        <FemaGoTable.TextCell width={5}>
          <Select
            placeholder="Score"
            id={`${part}-${factor.replace(/ /g, '-')}-score`}
            name={`${part}-${factor}-score`}
            title="Score"
            value={value}
            displayError={this.getError(score, 'score').displayError}
            errorMessages={this.getError(score, 'score').errorMessages}
            options={scoringOptions}
            handleChange={(e) =>
              this.handleChange('value', _.toNumber(e.target.value), score)
            }
            handleBlur={() => this.saveScores(score, 'score')}
          />
        </FemaGoTable.TextCell>
        <FemaGoTable.TextCell width={7}>
          <TextAreaField
            title="Justification"
            id={`${part}-${factor}-justification`}
            name={`${part}-${factor}-justification`}
            value={justification}
            displayError={this.getError(score, 'justification').displayError}
            errorMessages={this.getError(score, 'justification').errorMessages}
            handleChange={(e) =>
              this.handleChange('justification', e.target.value, score)
            }
            handleBlur={() => this.saveScores(score, 'justification')}
          />
        </FemaGoTable.TextCell>
      </FemaGoTable.Row>
    );
  };

  renderFactorScores = (partScores) => {
    const {sessionId, taskId} = this.props;
    const viewApplicationUrl = `/panelReview/sessions/${sessionId}/tasks/${taskId}/view`;
    const groupedScoresByFactors = _.groupBy(partScores, 'factor');
    return _.map(groupedScoresByFactors, (factorScores, factor) => (
      <Segment>
        <Header as="h4">
          {factor}&nbsp;&nbsp;
          {
            <a target="_blank" href={viewApplicationUrl}>
              View in Application
            </a>
          }
        </Header>
        <FemaGoTable type="static" summary={factor}>
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Reviewer</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Score</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Justification</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            {_.map(
              _.sortBy(factorScores, (score) => (this.isCurrentReviewer(score) ? 0 : 1)),
              (score) => {
                return (
                  <React.Fragment>
                    {this.isCurrentReviewer(score) ? (
                      this.renderEditableScores(score)
                    ) : (
                      <FemaGoTable.Row>
                        <FemaGoTable.TextCell width={4}>
                          {_.get(score, 'userId', '')}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell width={5}>
                          {_.get(score, 'text', '')}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell width={7}>
                          {_.get(score, 'justification', '')}
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    )}
                  </React.Fragment>
                );
              }
            )}
          </FemaGoTable.Body>
        </FemaGoTable>
      </Segment>
    ));
  };

  render() {
    const {applicantName} = this.props;
    const {scores, refItems} = this.state;
    const groupedScoresByPart = _.groupBy(scores, 'part');
    return (
      <div id="main">
        <Header as="h2">{applicantName}</Header>
        {_.map(groupedScoresByPart, (score, part) => (
          <React.Fragment>
            <Header as="h3">{getItemNameFromRef(part, refItems) || part}</Header>
            {this.renderFactorScores(score)}
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default connectWithCore(TableDiscussion);
